import React, { useEffect, useState } from "react";
import {
  Alert, Box, Button, Card, CardContent, LinearProgress, Stack,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useParams } from "react-router-dom";
import { TangoOrderDetail, tangoOrderService } from "../../services/order/tangoOrderService";

const money = new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" });
const number = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 });

export default function TangoOrderDetailsPage() {
  const { orderId } = useParams<{ orderId: string }>();
  const [details, setDetails] = useState<TangoOrderDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    setDetails([]);
    setError("");
    if (!orderId) {
      setError("No se indicó el pedido a consultar.");
      setLoading(false);
      return () => controller.abort();
    }
    setLoading(true);
    tangoOrderService.getDetails(orderId, controller.signal)
      .then(data => { if (!controller.signal.aborted) setDetails(data); })
      .catch(err => {
        if (!controller.signal.aborted)
          setError(err.response?.data?.message || "No se pudo cargar el detalle del pedido.");
      })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [orderId]);

  return (
    <Card>
      <CardContent>
        <Stack direction="row" alignItems="center" gap={2} mb={3} flexWrap="wrap">
          <Button component={Link} to="/orders/tango" startIcon={<ArrowBackIcon />}>Volver a pedidos</Button>
          <Typography variant="h5" color="primary">Detalle del pedido</Typography>
        </Stack>
        <Box aria-busy={loading}>
          {loading && <LinearProgress aria-label="Cargando detalle del pedido" />}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TableContainer>
            <Table aria-label="Detalle del pedido">
              <TableHead>
                <TableRow>
                  <TableCell>Producto</TableCell>
                  <TableCell align="right">Cantidad</TableCell>
                  <TableCell align="right">Precio unitario</TableCell>
                  <TableCell align="right">Descuento</TableCell>
                  <TableCell align="right">Precio total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {details.map(detail => (
                  <TableRow key={detail.orderDetailId}>
                    <TableCell>{detail.productDescription || "—"}</TableCell>
                    <TableCell align="right">{number.format(detail.quantity)}</TableCell>
                    <TableCell align="right">{money.format(detail.unitPrice)}</TableCell>
                    <TableCell align="right">{number.format(detail.discountPercentage)} %</TableCell>
                    <TableCell align="right">{money.format(detail.totalPrice)}</TableCell>
                  </TableRow>
                ))}
                {!loading && !error && details.length === 0 && (
                  <TableRow><TableCell colSpan={5} align="center">El pedido no tiene detalles.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </CardContent>
    </Card>
  );
}
